import { render, staticRenderFns } from "./LegalTermsText.vue?vue&type=template&id=094695a8&scoped=true&"
import script from "./LegalTermsText.vue?vue&type=script&lang=js&"
export * from "./LegalTermsText.vue?vue&type=script&lang=js&"
import style0 from "./LegalTermsText.vue?vue&type=style&index=0&id=094695a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094695a8",
  null
  
)

export default component.exports